import { useState, useContext } from 'react';
import { IonContent, IonPage, IonGrid, IonRow, IonCol, IonInput, IonButton, useIonViewDidEnter, IonIcon } from '@ionic/react';
import Navbar from '../../components/Navbar';
import './styles.css';
import axios from 'axios';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";
import MonthlyTypeEnum from '../../enum/monthly-type-enum';
import { MonthlyDataHelper } from '../../services/monthly-data-helper';
import { arrowForwardCircle } from 'ionicons/icons';

const Home: React.FC = () => {
    const { CurrentUser } = useContext(AppContext);
    const token = CurrentUser ? CurrentUser.token : null;
    const isEscWorks = CurrentUser ? CurrentUser.isEscWorks : false;
    const groupName = CurrentUser ? CurrentUser.group : '';

    const currentYear = GetCurrentYear() - 2000;
    let current_year = currentYear + '-' + (currentYear + 1);
    let previous_year = (currentYear - 1) + '-' + currentYear;

    const currentFullYear = GetCurrentYear();
    let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
    let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

    const dataUrl = `${ServerUrl}/semiannually/1.4`;
    const dataSubmittedUrl = `${ServerUrl}/semiannually/1.4/Submitted`;

    const sepFebQuater = "Sep-Feb";
    const marAugQuater = "Mar-Aug";

    const data = [
        { name: "5" },
        { name: "4" },
        { name: "3" },
        { name: "2" },
        { name: "1" },
        { name: "n/a" },
    ];

    const [SepFebRowStates, SetSepFebRowStates] = useState<Array<{ name: string, isEqualSum: boolean }>>([
        { name: "5", isEqualSum: true },
        { name: "4", isEqualSum: true },
        { name: "3", isEqualSum: true },
        { name: "2", isEqualSum: true },
        { name: "1", isEqualSum: true },
        { name: "n/a", isEqualSum: true },
    ]);

    const [MarAugRowStates, SetMarAugRowStates] = useState<Array<{ name: string, isEqualSum: boolean }>>([
        { name: "5", isEqualSum: true },
        { name: "4", isEqualSum: true },
        { name: "3", isEqualSum: true },
        { name: "2", isEqualSum: true },
        { name: "1", isEqualSum: true },
        { name: "n/a", isEqualSum: true },
    ]);

    const [TotalSepFebNonEscWorksSum, SetTotalSepFebNonEscWorksSum] = useState<Array<string>>(["0", "0", "0", "0", "0", "0"]);
    const [TotalSepFebEscWorksDashboardSum, SetTotalSepFebEscWorksDashboardSum] = useState<Array<string>>(["0", "0", "0", "0", "0", "0"]);
    const [TotalMarAugNonEscWorksSum, SetTotalMarAugNonEscWorksSum] = useState<Array<string>>(["0", "0", "0", "0", "0", "0"]);
    const [TotalMarAugEscWorksDashboardSum, SetTotalMarAugEscWorksDashboardSum] = useState<Array<string>>(["0", "0", "0", "0", "0", "0"]);
    
    const [CurrentData, SetCurrentData] = useState<Array<any>>([]);
    const [PreviousData, SetPreviousData] = useState<Array<any>>([]);

    const [CurrentFirstRates, SetCurrentFirstRates] = useState<Array<string>>(["0", "0", "0", "0", "0", "0", "0"]);
    const [CurrentSecondRates, SetCurrentSecondRates] = useState<Array<string>>(["0", "0", "0", "0", "0", "0","0"]);
    const [PreviousFirstRates, SetPreviousFirstRates] = useState<Array<string>>(["0", "0", "0", "0", "0", "0","0"]);
    const [PreviousSecondRates, SetPreviousSecondRates] = useState<Array<string>>(["0", "0", "0", "0", "0", "0", "0"]);
    const [CurrentAvg, SetCurrentAvg] = useState<Array<string>>(["0", "0"]);
    const [PreviousAvg, SetPreviousAvg] = useState<Array<string>>(["0", "0"]);
    const [YearAvg, SetYearAvg] = useState<string>("");

    useIonViewDidEnter(() => {
        axios.get(`${dataUrl}?year=${current_year}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetCurrentData(res.data);
                SetCurrentFirstRates(getAvgData(res.data, current_year, sepFebQuater))
                SetCurrentSecondRates(getAvgData(res.data, current_year, marAugQuater))
                SetCurrentAvg([getTotalAvg(res.data, current_year, sepFebQuater), getTotalAvg(res.data, current_year, marAugQuater)])
                SetYearAvg(getYearAvg(res.data, current_year));

                SetTotalSepFebNonEscWorksSum(getAvgData(res.data, current_year, sepFebQuater, MonthlyTypeEnum.NonEscWorksData));
                SetTotalSepFebEscWorksDashboardSum(getAvgData(res.data, current_year, sepFebQuater, MonthlyTypeEnum.EscWorksDashboardData));
                
                setSepFebRawStates(res.data);

                SetTotalMarAugNonEscWorksSum(getAvgData(res.data, current_year, marAugQuater, MonthlyTypeEnum.NonEscWorksData));
                SetTotalMarAugEscWorksDashboardSum(getAvgData(res.data, current_year, marAugQuater, MonthlyTypeEnum.EscWorksDashboardData));
                
                setMarAugRawStates(res.data);
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });

        axios.get(`${dataUrl}?year=${previous_year}`, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (res.data && res.data.length > 0) {
                SetPreviousData(res.data);
                SetPreviousFirstRates(getAvgData(res.data, previous_year, sepFebQuater))
                SetPreviousSecondRates(getAvgData(res.data, previous_year, marAugQuater))
                SetPreviousAvg([getTotalAvg(res.data, previous_year, sepFebQuater), getTotalAvg(res.data, previous_year, marAugQuater)])
            }
        }, err => {
            console.log("Fail to get data. " + JSON.stringify(err))
        });
    });

    // SepFeb section   

    const updateSubmittedData = (quater: string, subject: string) => {
        const monthData = CurrentData.find(element => element.year === current_year && element.quater == quater && element.subject == subject);
        const floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
        const floatNonEscWorksValue = MonthlyDataHelper.tryParseFloat(monthData.nonEscWorksData).parsedValue;
        const updatedValue = floatEscWorksDashBoardValue + floatNonEscWorksValue

        axios.post(dataSubmittedUrl, {"quater": quater, "value": updatedValue, "year": current_year, "subject": subject}, {
          headers: {
            'Authorization': "Bearer " + token,          
          }
        }).then(res => {
            SetCurrentData(res.data);
            SetCurrentFirstRates(getAvgData(res.data, current_year, sepFebQuater))
            SetCurrentSecondRates(getAvgData(res.data, current_year, marAugQuater))
            SetCurrentAvg([getTotalAvg(res.data, current_year, sepFebQuater), getTotalAvg(res.data, current_year, marAugQuater)])
            SetYearAvg(getYearAvg(res.data, current_year));

            SetTotalSepFebNonEscWorksSum(getAvgData(res.data, current_year, sepFebQuater, MonthlyTypeEnum.NonEscWorksData));
            SetTotalSepFebEscWorksDashboardSum(getAvgData(res.data, current_year, sepFebQuater, MonthlyTypeEnum.EscWorksDashboardData));
            
            setSepFebRawStates(res.data);

            SetTotalMarAugNonEscWorksSum(getAvgData(res.data, current_year, marAugQuater, MonthlyTypeEnum.NonEscWorksData));
            SetTotalMarAugEscWorksDashboardSum(getAvgData(res.data, current_year, marAugQuater, MonthlyTypeEnum.EscWorksDashboardData));
            
            setMarAugRawStates(res.data);
        })
      }

    const setSepFebRawStates = (inititalData: Array<any>) => {
      const yearDataArray = inititalData.filter(element => element.year === current_year && element.quater == sepFebQuater);
      yearDataArray.forEach(monthData => {
        updateSepFebRowStates(monthData.subject, current_year, monthData.nonEscWorksData, monthData.escWorksDashboardData, monthData.number);
      });
    }

    const updateSepFebNonEscEorksData = (index: string, value: any, year: string, monthlyType: MonthlyTypeEnum) => {
      saveData(year, sepFebQuater, index, "Number", value, monthlyType);

      updateSepFebRowStates(index, year, value);
    }

    const isSumEqual = (allData: any[], month: string,  year: string, 
      nonEscWorksValue: any, escWorksDashboardValue: any = null, submittedValue: any = null) : boolean => 
    {
      const isParsed = MonthlyDataHelper.tryParseFloat(nonEscWorksValue);
      if (!isParsed) {
        return true;
      }

      const floatNonEscWorksValue: number = isParsed.parsedValue;
      let floatEscWorksDashBoardValue: number;
      let floatSubmittedValue: number;
      if (escWorksDashboardValue != null) {
        floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(escWorksDashboardValue).parsedValue;
        floatSubmittedValue = MonthlyDataHelper.tryParseFloat(submittedValue).parsedValue;
      }
      else{
        const monthData = allData.find(element => element.year === year && element.quater == month);
        floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
        floatSubmittedValue = MonthlyDataHelper.tryParseFloat(monthData.number).parsedValue;
      }

      return  floatNonEscWorksValue + floatEscWorksDashBoardValue == floatSubmittedValue;
    }
    
    const updateSepFebRowStates = (index: string,  year: string, nonEscWorksValue: any, 
          escWorksDashboardValue: any = null, submittedValue: any = null) => {
        SetSepFebRowStates(prevMonthState => {
          const newState = prevMonthState.map(prevMonth => {
    
            if (prevMonth.name == index) {
              return {...prevMonth, isEqualSum: isSumEqual(CurrentData, sepFebQuater, year, nonEscWorksValue, escWorksDashboardValue, submittedValue)};
            }
    
            return prevMonth;
          });
    
          return newState;
        });
    }
    //end 

    //MarAug section
    const setMarAugRawStates = (inititalData: Array<any>) => {
        const yearDataArray = inititalData.filter(element => element.year === current_year && element.quater == marAugQuater);
        yearDataArray.forEach(monthData => {
          updateMarAugRowStates(monthData.subject, current_year, monthData.nonEscWorksData, monthData.escWorksDashboardData, monthData.number);
        });
      }
  
      const updateMarAugNonEscEorksData = (index: string, value: any, year: string, monthlyType: MonthlyTypeEnum) => {
        saveData(year, marAugQuater, index, "Number", value, monthlyType);
  
        updateMarAugRowStates(index, year, value);
      }
      
      const updateMarAugRowStates = (index: string,  year: string, nonEscWorksValue: any, 
            escWorksDashboardValue: any = null, submittedValue: any = null) => {
          SetMarAugRowStates(prevMonthState => {
            const newState = prevMonthState.map(prevMonth => {
      
              if (prevMonth.name == index) {
                return {...prevMonth, isEqualSum: isSumEqual(CurrentData, marAugQuater, year, nonEscWorksValue, escWorksDashboardValue, submittedValue)};
              }
      
              return prevMonth;
            });
      
            return newState;
          });
      }
    //end

    const getData = (dataArray: Array<any>, quater: string, subject: string, name: string, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default) => {
        let num = 0;
        for (var i = 0; i < dataArray.length; i++) {
            let e = dataArray[i];
            if (e.quater === quater && e.subject === subject && name === "Number") {
                return parseFloat(getDataByMontlyType(e, monthlyType));
            }
            else if (e.quater === quater && e.subject.trim() === subject.trim() && name === "Rate") {
                return parseFloat(e.rate);
            }
        }
        return num;
    }

    const saveData = (year: string, quater: string, subject: string, name: string, value: any, monthlyType: MonthlyTypeEnum) => {
        axios.post(dataUrl, { "year": year, "quater": quater, "subject": subject, "name": name, "value": value, "monthlyType": monthlyType }, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        }).then(res => {
            if (year === current_year) {
                SetCurrentData(res.data);
                SetCurrentFirstRates(getAvgData(res.data, current_year, sepFebQuater))
                SetCurrentSecondRates(getAvgData(res.data, current_year, marAugQuater))
                SetCurrentAvg([getTotalAvg(res.data, current_year, sepFebQuater), getTotalAvg(res.data, current_year, marAugQuater)])
                SetYearAvg(getYearAvg(res.data, current_year));
                SetTotalSepFebNonEscWorksSum(getAvgData(res.data, current_year, sepFebQuater, MonthlyTypeEnum.NonEscWorksData));
                SetTotalSepFebEscWorksDashboardSum(getAvgData(res.data, current_year, sepFebQuater, MonthlyTypeEnum.EscWorksDashboardData));
                SetTotalMarAugNonEscWorksSum(getAvgData(res.data, current_year, marAugQuater, MonthlyTypeEnum.NonEscWorksData));
                SetTotalMarAugEscWorksDashboardSum(getAvgData(res.data, current_year, marAugQuater, MonthlyTypeEnum.EscWorksDashboardData));
            } else {
                SetPreviousData(res.data);
                SetPreviousFirstRates(getAvgData(res.data, previous_year, sepFebQuater))
                SetPreviousSecondRates(getAvgData(res.data, previous_year, marAugQuater))
                SetPreviousAvg([getTotalAvg(res.data, previous_year, sepFebQuater), getTotalAvg(res.data, previous_year, marAugQuater)])
            }
        }, err => console.log("error"));
    }

    const getAvg = (year: string, quater: string, subject: string) => {
        let index = 0;
        if (subject !== 'n/a') {
            index = parseInt(subject);
        }
        if (index > 5) return "0";

        if (year === current_year) {
            if (quater === sepFebQuater) {
                return CurrentFirstRates[index];
            } else if (quater === marAugQuater) {
                return CurrentSecondRates[index];
            }
        }
        else if (year === previous_year) {
            if (quater === sepFebQuater) {
                return PreviousFirstRates[index];
            } else if (quater === marAugQuater) {
                return PreviousSecondRates[index];
            }
        }

        return "0";
    }

    const getDataByMontlyType = (element: any, monthlyType: MonthlyTypeEnum) => {
        if (monthlyType == MonthlyTypeEnum.Default){
          return element.number;
        }
        else if (monthlyType == MonthlyTypeEnum.NonEscWorksData){
          return element.nonEscWorksData;
        }
        else{
          return element.escWorksDashboardData;
        }
      }

    const getAvgData = (dataArray: Array<any>, year: string, quater: string, mothlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default) => {
        let sum = 0;
        let results = ["0", "0", "0", "0", "0", "0","0"];

        dataArray.forEach(e => {
            if (e.year === year && e.quater === quater) {
                sum += parseFloat(getDataByMontlyType(e, mothlyType));
            }
        })

        if (sum > 0) {
            dataArray.forEach(e => {
                if (e.year === year && e.quater === quater) {
                    let index = 0;
                    if (e.subject !== 'n/a') {
                        index = parseInt(e.subject);
                    }
                    
                    if (index >= 0 && index < 6) {
                        
                        results[index] = (getDataByMontlyType(e, mothlyType) * 100 / sum).toFixed(2) + "%";
                    }
                }
            })
        }

        results[6] = sum.toLocaleString();
        return results;
    }

    const getTotalAvg = (dataArray: Array<any>, year: string, quater: string) => {
        let sum = 0;
        let ratedSum = 0;

        dataArray.forEach(e => {
            if (e.year === year && e.quater === quater) {
                /*alert("ok");*/
                if (e.subject !== 'n/a') {
                    sum += parseFloat(e.number);
                }
            }
        })

        dataArray.forEach(e => {
            if (e.year === year && e.quater === quater) {
                let index = parseInt(e.subject);
                if (index > 0 && index < 6) {
                    ratedSum += parseFloat(e.number) * index;
                }
            }
        })

        if (sum <= 0) return "0";

        return (ratedSum / sum).toFixed(2);
    }

    const getYearAvg = (dataArray: Array<any>, year: string) => {
        const d1 = getRatedSum(dataArray, year, sepFebQuater);
        const d2 = getRatedSum(dataArray, year, marAugQuater);
        const sum = d1[0] + d2[0];
        const ratedSum = d1[1] + d2[1];

        if (sum === 0) return "";
        return (ratedSum / sum).toFixed(2);
    };

    const getRatedSum = (dataArray: Array<any>, year: string, quater: string) => {
        let sum = 0;
        let ratedSum = 0;

        dataArray.forEach(e => {
            if (e.year === year && e.quater === quater) {
                if (e.subject !== 'n/a') {
                    sum += parseFloat(e.number);
                }
            }
        })

        dataArray.forEach(e => {
            if (e.year === year && e.quater === quater) {
                let index = parseInt(e.subject);
                if (index > 0 && index < 6) {
                    ratedSum += parseFloat(e.number) * index;
                }
            }
        })

        return [sum, ratedSum];
    }


    const onSaveExcel = () => {
        axios.get(`${dataUrl}/excel?current=${current_year}&previous=${previous_year}`, {
            headers: {
                'Authorization': "Bearer " + token,
            },
            responseType: 'blob',
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Semi-annual 1.4.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    return (
        <IonPage>
            <Navbar />
            <IonContent fullscreen>
                <div className='content-container'>
                    <div style={{ marginBottom: '10px', marginTop: '20px' }}>{groupName}</div>
                    <div style={{ marginBottom: '20px' }}>Indicator 1.4 - Training Evaluation Rating (Workshops that impact student performance)</div>
                    <IonButton color="primary" style={{ textTransform: 'none' }} onClick={onSaveExcel}>Export to Excel</IonButton>
                </div>
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>Workshop Evaluation Ratings</div>
                <div className='flex-container'>
                    <div style={{ flexGrow: '1' }}>
                        <IonGrid>
                            {/*<IonRow>*/}
                            {/*    <IonCol offset="2"  className='no-border'><IonInput min='0' value={'September - February'} readonly /></IonCol>*/}
                            {/*</IonRow>*/}
                            {/*<IonRow>*/}
                            {/*    <IonCol offset="3" className='data-row right-border bottom-border table-header'>*/}
                            {/*        <IonInput min='0' value={current_full_year} readonly />*/}
                            {/*    </IonCol>*/}
                            {/*    <IonCol offset="2" className='data-row right-border bottom-border table-header'>*/}
                            {/*        <IonInput min='0' value={previous_full_year} readonly />*/}
                            {/*    </IonCol>*/}
                            {/*</IonRow>*/}
                            <IonRow>
                                <IonCol offset="2" size="10" style={{ fontWeight: 'bold' }} className='no-border'><IonInput min='0' value={'September - February'} readonly /></IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol offset="3" size="3" className='data-row right-border bottom-border table-header'>
                                    <IonInput min='0' value={current_full_year} readonly />
                                </IonCol>
                                <IonCol offset="2" size="3" className='data-row right-border bottom-border table-header'>
                                    <IonInput min='0' value={previous_full_year} readonly />
                                </IonCol>
                            </IonRow>
                            <IonRow className="header-row">
                                <IonCol size="2" className='data-row no-border'></IonCol>
                                <IonCol size="auto" style={{fontSize: '14px', display: 'none'}} className='data-row'>
                                    <IonInput  style={{width: '140px', display:'none'}} min='0'  value="Non-escWorks Data" readonly />
                                </IonCol>
                                <IonCol size="auto" style={{fontSize: '14px', display:'none'}} className='data-row'>
                                    <IonInput style={{width: '180px'}} min='0' value="escWorks Dashboard Data" readonly />
                                </IonCol>
                                {/*<IonCol className='data-row right-border'>*/}
                                {/*  <IonInput min='0' value="Number of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                {/*<IonCol className='data-row right-border'>*/}
                                {/*  <IonInput min='0' value="% of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                {/*<IonCol className='data-row right-border'>*/}
                                {/*  <IonInput min='0' value="Number of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                {/*<IonCol className='data-row right-border'>*/}
                                {/*  <IonInput min='0' value="% of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                               
                                <IonCol size="3" className='data-row no-border'><IonInput min='0' value={'Number of Ratings'} readonly /></IonCol>
                                <IonCol size="2" className='data-row no-border'><IonInput min='0' value={'% of Ratings'} readonly /></IonCol>
                                <IonCol size="3" className='data-row no-border'><IonInput min='0' value={'Number of Ratings'} readonly /></IonCol>
                                <IonCol size="2" className='data-row no-border'><IonInput min='0' value={'% of Ratings'} readonly /></IonCol>
                            </IonRow>
                            {SepFebRowStates.map((d, index) => {
                                if(d.isEqualSum){
                                    return (
                                        <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                                            <IonCol className='data-row' size="2"><IonInput min='0' value={d.name} readonly /></IonCol>
                                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                                              <IonInput style={{width: '140px'}} min='0'  type="number" step="1" value={getData(CurrentData, sepFebQuater, d.name, "Number", MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                                  updateSepFebNonEscEorksData(d.name, e.target.value, current_year, MonthlyTypeEnum.NonEscWorksData);
                                                }}>     
                                              </IonInput>
                                            </IonCol>
                                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                                                <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentData, sepFebQuater, d.name, "Number", MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                                    //saveTotalData(name, e.target.value, current_year, true);
                                                }}>     
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row' size="3">
                                                <IonInput min='0' type="number" step="1" value={getData(CurrentData, sepFebQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    saveData(current_year, sepFebQuater, d.name, "Number", e.target.value, MonthlyTypeEnum.Default)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row' size="2">
                                                <IonInput min='0' value={getAvg(current_year, sepFebQuater, d.name)} readonly />
                                            </IonCol>
                                            <IonCol className='data-row' size="3">
                                                <IonInput min='0' readonly type="number" step="1" value={getData(PreviousData, sepFebQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    // saveData(previous_year, sepFebQuater, d.name, "Number", e.target.value)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol size="2" className='data-row right-border'>
                                                <IonInput min='0' value={getAvg(previous_year, sepFebQuater, d.name)} readonly />
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                else{
                                    return (
                                        <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                                            <IonCol className='data-row' size="2"><IonInput min='0' value={d.name} readonly /></IonCol>
                                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                                                <IonInput style={{width: '140px'}} min='0'  type="number" step="1" value={getData(CurrentData, sepFebQuater, d.name, "Number", MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                                        updateSepFebNonEscEorksData(d.name, e.target.value, current_year, MonthlyTypeEnum.NonEscWorksData);
                                                    }}>     
                                                </IonInput>
                                            </IonCol>
                                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                                                <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentData, sepFebQuater, d.name, "Number", MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                                    //saveTotalData(name, e.target.value, current_year, true);
                                                    }}>     
                                                </IonInput>
                                                <IonButton fill="clear" onClick={() => updateSubmittedData(sepFebQuater, d.name)} className="arrow-button">
                                                    <IonIcon icon={arrowForwardCircle} />
                                                </IonButton>
                                            </IonCol>
                                            <IonCol className='data-row' size="3">
                                                <IonInput min='0' type="number" step="1" value={getData(CurrentData, sepFebQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    saveData(current_year, sepFebQuater, d.name, "Number", e.target.value, MonthlyTypeEnum.Default)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row' size="2">
                                                <IonInput min='0' value={getAvg(current_year, sepFebQuater, d.name)} readonly />
                                            </IonCol>
                                            <IonCol className='data-row' size="3">
                                                <IonInput style={{width: '190px'}} min='0' readonly type="number" step="1" value={getData(PreviousData, sepFebQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    // saveData(previous_year, sepFebQuater, d.name, "Number", e.target.value)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol size="2" className='data-row right-border'>
                                                <IonInput min='0' value={getAvg(previous_year, sepFebQuater, d.name)} readonly />
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                            })}
                            <IonRow>
                                <IonCol size="2" className='data-row top-border'></IonCol>
                                <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                                  <div style={{paddingRight: '14px',  width: '140px'}}>
                                    <IonInput value={TotalSepFebNonEscWorksSum[0]} readonly />
                                  </div>
                                </IonCol>
                                <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                                  <div style={{paddingRight: '14px', width: '180px'}}>
                                    <IonInput value={TotalSepFebEscWorksDashboardSum[0]} readonly />
                                  </div>
                                </IonCol>
                                <IonCol size="3" className='data-row bottom-border table-header foot-text-color'>
                                    <div style={{ paddingRight: '14px'}}>
                                        <IonInput min='0' value={CurrentFirstRates[6]} readonly />
                                    </div>
                                </IonCol>
                                <IonCol className='data-row' size="2"></IonCol>
                                <IonCol size="3" className='data-row bottom-border right-border table-header foot-text-color'>
                                    <div style={{ paddingRight: '14px'}}>
                                        <IonInput min='0' value={PreviousFirstRates[6]} readonly />
                                    </div>
                                </IonCol>
                                {/*<IonCol style={{marginRight: "4px", borderLeft: "0px"}} className='data-row' size="auto">*/}
                                {/*    <div style={{width: '205px'}}></div>*/}
                                {/*</IonCol>*/}
                                <IonCol className='data-row' size="2"></IonCol>
                            </IonRow>

                            <div style={{ height: '20px' }}></div>
                            <IonRow>
                                <IonCol size="5" className='no-border'>
                                    <IonInput min='0' value={'Semi-Annual Average Rating'} readonly />
                                </IonCol>
                            </IonRow>
                            <IonRow className="header-row">
                                <IonCol size="8" className='data-row border right-border'><IonInput min='0' value={'Number of Ratings'} readonly /></IonCol>
                            </IonRow>
                            <IonRow className="header-row">
                                <IonCol size="4" className='data-row border right-border'><IonInput min='0' value={current_full_year} readonly /></IonCol>
                                <IonCol size="4" className='data-row border right-border'><IonInput min='0' value={previous_full_year} readonly /></IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size="4" className='data-row bottom-border table-header foot-text-color'>
                                    <IonInput min='0' value={CurrentAvg[0]} readonly />
                                </IonCol>
                                <IonCol size="4" className='data-row bottom-border right-border table-header foot-text-color'>
                                    <IonInput min='0' value={PreviousAvg[0]} readonly />
                                </IonCol>
                            </IonRow>


                        </IonGrid>
                    </div>
                    <div style={{ flexGrow: '1' }}>
                        <IonGrid>
                            <IonRow>
                                <IonCol offset="2" size="10" style={{ fontWeight: 'bold' }} className='no-border'><IonInput min='0' value={'March - August'} readonly /></IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol offset="3" size="3" className='data-row right-border bottom-border table-header'><IonInput min='0' value={current_full_year} readonly /></IonCol>
                                <IonCol offset="2" size="3" className='data-row right-border bottom-border table-header'><IonInput min='0' value={previous_full_year} readonly /></IonCol>
                            </IonRow>
                            <IonRow className="header-row">
                                <IonCol size="2" className='data-row no-border'></IonCol>
                                <IonCol size="auto" style={{fontSize: '14px', display:'none'}} className='data-row'>
                                    <IonInput  style={{width: '140px'}} min='0'  value="Non-escWorks Data" readonly />
                                </IonCol>
                                <IonCol size="auto" style={{ fontSize: '14px', display: 'none' }} className='data-row'>
                                    <IonInput style={{width: '180px'}} min='0' value="escWorks Dashboard Data" readonly />
                                </IonCol>
                                {/*<IonCol size="auto" style={{fontSize: '14px'}} className='data-row right-border'>*/}
                                {/*  <IonInput min='0'  style={{width: '190px'}} value="Number of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                {/*<IonCol size="auto" style={{fontSize: '14px'}} className='data-row right-border'>*/}
                                {/*  <IonInput min='0'  style={{width: '188px'}} value="% of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                {/*<IonCol size="auto" style={{fontSize: '14px'}} className='data-row right-border'>*/}
                                {/*  <IonInput min='0'  style={{width: '190px'}} value="Number of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                {/*<IonCol size="auto" style={{fontSize: '14px'}} className='data-row right-border'>*/}
                                {/*  <IonInput min='0'  style={{width: '204px'}} value="% of Ratings" readonly />*/}
                                {/*</IonCol>*/}
                                <IonCol size="3" className='data-row no-border'><IonInput min='0' value={'Number of Ratings'} readonly /></IonCol>
                                <IonCol size="2" className='data-row no-border'><IonInput min='0' value={'% of Ratings'} readonly /></IonCol>
                                <IonCol size="3" className='data-row no-border'><IonInput min='0' value={'Number of Ratings'} readonly /></IonCol>
                                <IonCol size="2" className='data-row no-border'><IonInput min='0' value={'% of Ratings'} readonly /></IonCol>
                            </IonRow>
                            {MarAugRowStates.map((d, index) => {
                                if(d.isEqualSum){
                                    return (
                                        <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                                            <IonCol className='data-row' size="2"><IonInput min='0' value={d.name} readonly /></IonCol>
                                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                                              <IonInput style={{width: '140px'}} min='0'  type="number" step="1" value={getData(CurrentData, marAugQuater, d.name, "Number", MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                                  updateMarAugNonEscEorksData(d.name, e.target.value, current_year, MonthlyTypeEnum.NonEscWorksData);
                                                }}>     
                                              </IonInput>
                                            </IonCol>
                                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                                                <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentData, marAugQuater, d.name, "Number", MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                                    //saveTotalData(name, e.target.value, current_year, true);
                                                }}>     
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row' size="3">
                                                <IonInput min='0' type="number" step="1" value={getData(CurrentData, marAugQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    saveData(current_year, marAugQuater, d.name, "Number", e.target.value, MonthlyTypeEnum.Default)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row' size="2">
                                                <IonInput min='0' value={getAvg(current_year, marAugQuater, d.name)} readonly />
                                            </IonCol>
                                            <IonCol className='data-row' size="3">
                                                <IonInput min='0' readonly type="number" step="1" value={getData(PreviousData, marAugQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    // saveData(previous_year, marAugQuater, d.name, "Number", e.target.value)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row right-border'>
                                                <IonInput min='0' value={getAvg(previous_year, marAugQuater, d.name)} readonly />
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                else{
                                    return (
                                        <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                                            <IonCol className='data-row' size="2"><IonInput min='0' value={d.name} readonly /></IonCol>
                                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                                                <IonInput style={{width: '140px'}} min='0'  type="number" step="1" value={getData(CurrentData, marAugQuater, d.name, "Number", MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                                        updateMarAugNonEscEorksData(d.name, e.target.value, current_year, MonthlyTypeEnum.NonEscWorksData);
                                                    }}>     
                                                </IonInput>
                                            </IonCol>
                                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                                                <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentData, marAugQuater, d.name, "Number", MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                                    //saveTotalData(name, e.target.value, current_year, true);
                                                    }}>     
                                                </IonInput>
                                                <IonButton fill="clear" onClick={() => updateSubmittedData(marAugQuater, d.name)} className="arrow-button">
                                                    <IonIcon icon={arrowForwardCircle} />
                                                </IonButton>
                                            </IonCol>
                                            <IonCol className='data-row' size="auto">
                                                <IonInput min='0' type="number" step="1" value={getData(CurrentData, marAugQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    saveData(current_year, marAugQuater, d.name, "Number", e.target.value, MonthlyTypeEnum.Default)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row' size="auto">
                                                <IonInput min='0' value={getAvg(current_year, marAugQuater, d.name)} readonly />
                                            </IonCol>
                                            <IonCol className='data-row' size="auto">
                                                <IonInput min='0' readonly type="number" step="1" value={getData(PreviousData, marAugQuater, d.name, "Number")} placeholder="" onBlur={(e) => {
                                                    // saveData(previous_year, marAugQuater, d.name, "Number", e.target.value)
                                                }}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol className='data-row right-border'>
                                                <IonInput  min='0' value={getAvg(previous_year, marAugQuater, d.name)} readonly />
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                            })}
                            <IonRow>
                                <IonCol size="2" className='data-row top-border'></IonCol>
                                <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                                  <div style={{paddingRight: '14px',  width: '140px'}}>
                                    <IonInput value={TotalMarAugNonEscWorksSum[0]} readonly />
                                  </div>
                                </IonCol>
                                <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                                  <div style={{paddingRight: '14px', width: '180px'}}>
                                    <IonInput value={TotalMarAugEscWorksDashboardSum[0]} readonly />
                                  </div>
                                </IonCol>
                                <IonCol size="3" className='data-row bottom-border foot-text-color table-header'>
                                    <div style={{ paddingRight: '14px'}}>
                                        <IonInput min='0' value={CurrentSecondRates[6]} readonly />
                                    </div>
                                </IonCol>
                                <IonCol className='data-row' size="2"></IonCol>
                                <IonCol size="3"  className='data-row bottom-border right-border foot-text-color table-header'>
                                    <div style={{ paddingRight: '14px'}}>
                                        <IonInput min='0' value={PreviousSecondRates[6]} readonly />
                                    </div>
                                </IonCol>
                                {/*<IonCol style={{marginRight: "4px", borderLeft: "0px"}} className='data-row' size="auto">*/}
                                {/*    <div style={{width: '205px'}}></div>*/}
                                {/*</IonCol>*/}
                                <IonCol className='data-row' size="2"></IonCol>
                            </IonRow>

                            <div style={{ height: '20px' }}></div>
                            <IonRow>
                                <IonCol size="5" className='no-border'>
                                    <IonInput min='0' value={'Semi-Annual Average Rating'} readonly />
                                </IonCol>
                            </IonRow>
                            <IonRow className="header-row">
                                <IonCol size="8" className='data-row border right-border'><IonInput min='0' value={'Number of Ratings'} readonly /></IonCol>
                            </IonRow>
                            <IonRow className="header-row">
                                <IonCol size="4" className='data-row border right-border'><IonInput min='0' value={current_full_year} readonly /></IonCol>
                                <IonCol size="4" className='data-row border right-border'><IonInput min='0' value={previous_full_year} readonly /></IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size="4" className='data-row bottom-border table-header foot-text-color'>
                                    <IonInput min='0' value={CurrentAvg[1]} readonly />
                                </IonCol>
                                <IonCol size="4" className='data-row bottom-border right-border table-header foot-text-color'>
                                    <IonInput min='0' value={PreviousAvg[1]} readonly />
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                </div>
                <div className='content-container' style={{ marginLeft: '20%', marginTop: '30px', marginBottom: '30px' }}>
                    <div style={{ flexGrow: '1' }}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size="4" className='data-row border right-border bottom-border'>
                                    <IonInput min='0' value={'Current Year Average Rating'} readonly />
                                </IonCol>
                                <IonCol size="4" className='data-row bottom-border right-border table-header foot-text-color'>
                                    <IonInput min='0' value={YearAvg} readonly />
                                </IonCol>
                                
                            </IonRow>
                        </IonGrid>
                    </div>
                </div>
                <div className='content-container'>
                    <div style={{ marginBottom: '10px'}}>Ratings of "N/A" do not factor into the calculation of the Semi-annual Average Rating or the Current Year Average Rating.</div>
                </div>
                <div style={{ marginBottom: '20px' }}></div>
            </IonContent>
        </IonPage>
    );
};

export default Home;
